import React from "react";
import { Typography, Button, Grid } from "antd";
import { ExclamationCircleOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { NEW_PLATFORM } from "../config";
import outrexLogo from "../assets/outrex_logo.svg";
import outrexPlatform from "../assets/outrex_platform.svg";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const MovedPage = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.lg;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        padding: isMobile ? "16px" : "16px 60px",
        gap: isMobile ? "24px" : "32px",
        alignItems: "center",
        width: "100%",
        flex: 1,
      }}
    >
      {/* Left: Banner + Introducing + CTA */}
      <div
        style={{
          flex: isMobile ? "unset" : 1,
          display: "flex",
          flexDirection: "column",
          alignItems: isMobile ? "center" : "flex-start",
          width: isMobile ? "100%" : "auto",
        }}
      >
        {/* Demo Period Banner */}
        <div
          style={{
            backgroundColor: "#fefce8",
            border: "1px solid #fde68a",
            borderRadius: "12px",
            padding: "16px 20px",
            marginBottom: "28px",
            maxWidth: isMobile ? "100%" : "480px",
          }}
        >
          <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
            <ExclamationCircleOutlined
              style={{ color: "#f59e0b", fontSize: "20px", marginTop: "2px" }}
            />
            <div>
              <Text
                strong
                style={{ color: "#d97706", fontSize: "15px", display: "block" }}
              >
                Demo Period Ended
              </Text>
              <Text style={{ color: "#555", fontSize: "13px", lineHeight: "1.5" }}>
                Your free demo access has expired. Continue with full access on
                our new platform — all your preferences will be waiting for you.
              </Text>
            </div>
          </div>
        </div>

        <Text
          style={{
            color: "#16a34a",
            fontSize: "13px",
            fontWeight: 600,
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            marginBottom: "12px",
          }}
        >
          INTRODUCING
        </Text>

        <Title
          level={isMobile ? 3 : 2}
          style={{
            fontWeight: 700,
            marginTop: 0,
            marginBottom: "16px",
            whiteSpace: "nowrap",
          }}
        >
          Our new platform:{" "}
          <img
            src={outrexLogo}
            alt={NEW_PLATFORM.name}
            style={{ height: isMobile ? "20px" : "28px", verticalAlign: "middle" }}
          />
        </Title>

        <Text
          style={{
            color: "#6b7280",
            fontSize: "16px",
            textAlign: isMobile ? "center" : "left",
            marginBottom: "28px",
          }}
        >
          Everything you loved — rebuilt and upgraded. Ready when you are.
        </Text>

        <Button
          size="large"
          href={NEW_PLATFORM.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            borderRadius: "999px",
            border: "2px solid #d0d7de",
            padding: "12px 32px",
            height: "auto",
            fontSize: "16px",
            fontWeight: 500,
            color: "#1a1a1a",
          }}
        >
          Go to new platform
          <ArrowRightOutlined />
        </Button>
      </div>

      {/* Right: Platform Preview */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: isMobile ? "center" : "flex-start",
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        <Text
          style={{
            color: "#6b7280",
            fontSize: "12px",
            fontWeight: 600,
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            marginBottom: "12px",
          }}
        >
          PLATFORM PREVIEW
        </Text>

        <div
          style={{
            width: "100%",
            maxHeight: isMobile ? "none" : "calc(100vh - 200px)",
            border: "1px solid #e5e7eb",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 4px 24px rgba(0, 0, 0, 0.06)",
          }}
        >
          <img
            src={outrexPlatform}
            alt={`${NEW_PLATFORM.name} platform preview`}
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MovedPage;
